import { cn } from "@/lib/utils";
import { Slider } from "@backpac/monica";
import { Volume2, VolumeX } from "lucide-react";

interface VolumeControlProps {
  className?: string;
  value: number;
  onChange: (volume: number) => void;
  onMuteClick: () => void;
  onUnmuteClick: () => void;
}

export function VolumeControl({ className, value, onChange, onMuteClick, onUnmuteClick }: VolumeControlProps) {
  return (
    <div className={cn("flex items-center gap-4 rounded-xl", className)}>
      {value > 0 ? (
        <button type="button" onClick={onMuteClick} className="p-1 rounded-lg transition-colors" aria-label="Mute">
          <Volume2 className="w-5 h-5 text-white" />
        </button>
      ) : (
        <button type="button" onClick={onUnmuteClick} className="p-1 rounded-lg transition-colors" aria-label="Unmute">
          <VolumeX className="w-5 h-5 text-white" />
        </button>
      )}
      <Slider value={value} onChange={onChange} />
    </div>
  );
}
